import { applicationListConstants } from "./applicationList.constants";

export const applicationListActions = {
	resetApplicationEntryState,
};

function resetApplicationEntryState() {
	return { type: applicationListConstants.RESET_APPLICATION_ENTRY_STATE };
}
